import { Component, Input, OnInit } from '@angular/core';
import { MasterDataService } from '../masterdata/masterdata.service';
import { InboundFileProcessing } from '../masterdata/models/InboundFileProcessing';
import { LabMDM, SelectableLab } from '../masterdata/models/lab';
import { Machine } from '../masterdata/models/machine';
import { OperetionHistoryDTO } from '../masterdata/models/operationHistory';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from "../utils/error-handler";
import { MdmInboundFileProcessingService } from './mdm-inbound-file-processing.service';

@Component({
  selector: 'app-mdm-inbound-file-processing',
  templateUrl: './mdm-inbound-file-processing.component.html',
  styleUrls: ['./mdm-inbound-file-processing.component.css']
})
export class MdmInboundFileProcessingComponent implements OnInit {


  @Input() masterLists: InboundFileProcessing[];
  @Input() tableCols: any[];
  @Input() title: string;
  @Input() labOptions: LabMDM[];
  @Input() checkSelectedLab: SelectableLab;
  @Input() loading:boolean;

  machineOptions: Machine[]
  masterList: InboundFileProcessing;
  selectedLabName: string;
  selectedLab: LabMDM;
  errorHandler: ErrorHandler = new ErrorHandler;
  puid = localStorage.getItem('PUID');
  labOption: LabMDM[] = [];
  blocked = false;
  displayMasterListDialog: boolean = false;
  isNewMasterList: boolean;
  handlerOptions: any[];
  selectedHandlerOption: any;
  selectedMachineTypeName: string;
  selectedMachineType: Machine;
  regexRunIdValue:string;
  locationValue:string;
  selectedMasterList: InboundFileProcessing;

  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService,
    private _mdmInboundFileService: MdmInboundFileProcessingService) { }

  ngOnInit() {

    this.handlerOptions = [
      {label:'FLX', name:'FLX'},
      {label:'FA', name:'FA'}
    ];

    this.getActiveOptionsForDropdowns();
  }
  getActiveOptionsForDropdowns(): any {
    this.labOption=[];
    this._masterDataService.getLabs(true).subscribe(
      results => {
        if (!results) {
          return;
        }  
        this.labOptions = results.data;
        this.labOptions.forEach(lab => {
          if (this.masterList && this.masterList.lab && lab._id == this.masterList.lab._id) {
            this.selectedLabName = this.masterList.lab.name;
            this.selectedLab = lab;
          }
        })
        if (!this.masterList || !this.masterList.lab || this.selectedLabName != this.masterList.lab.name)
          this.selectedLab = null;
        
          //Get the Lab details inside asynchornus call
        // and get drop down details for seleceted lab
        this.getDropDetailsBySelectedLab();
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
        }
    );
  }
  getDropDetailsBySelectedLab() {
    this.machineOptions = [];

    if(this.selectedLab){
      this._mdmInboundFileService.getMachineByLab(this.selectedLab, true).subscribe(
        results => {
          if (!results) {
            return;
          }
          this.machineOptions = results.data;
            this.machineOptions.forEach(type => {
              if (this.masterList && this.masterList.machine && type.name == this.masterList.machine.name) {
                this.selectedMachineTypeName = this.masterList.machine.name;
                this.selectedMachineType = type;
              }
            })
            if (!this.masterList || !this.masterList.machine || this.selectedMachineTypeName != this.masterList.machine.name)
              this.selectedMachineType = null;
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
        }
      );


    }
  }

  showDialogToAddMasterList(){
    this.isNewMasterList = true;
    this.masterList = new InboundFileProcessing();
    this.displayMasterListDialog = true;
    this.selectedLab = null;
    this.selectedHandlerOption=null;
    this.selectedMachineType=null;
    this.regexRunIdValue=null;
    this.locationValue=null;
    this.getActiveOptionsForDropdowns();
  }

  isSaveDisabled() {
    return !(this.masterList && this.masterList.name && this.selectedLab && this.selectedHandlerOption && this.selectedMachineType && this.locationValue);
  }

   //Insert or update Inbound file data
   saveMasterListData() { 
    let masterLists = [...this.masterLists];
    if (this.isNewMasterList) {
      this.saveMasterData(masterLists);
    }else {
      this.updateMasterList(masterLists)
    }

  }
  
  //Inserts a new Inbound file data in DB
  saveMasterData(masterLists: InboundFileProcessing[]) {

    this.masterList.lab = new LabMDM();
    this.masterList.lab = this.selectedLab;
    this.masterList.handler=this.selectedHandlerOption.name;

    this.masterList.machine = new Machine();
    this.masterList.machine=this.selectedMachineType;

    this.masterList.regexRunID=this.regexRunIdValue;
    this.masterList.location=this.locationValue;

    this.appendHistory("Inbound File Processing");
    this.blocked = true;
    this._mdmInboundFileService.addInboundFileData(this.masterList).subscribe(
      results => {
        if (!results) {
          return;
        }
        masterLists = [...this.masterLists];
        masterLists.push(results.data);
        this.masterLists = masterLists;
        this.masterList = null;
        this.blocked =false;
        this.displayMasterListDialog = false;
        this._messageService.addSuccessMessage({ severity: 'success', summary: 'Saved Inbound File Processing details!', detail: 'Inbound File Processing details is created.' });
      },
      error => {
        this.handleError(error);
      }
    );

  }

  updateMasterList(masterLists: any[]){
    this.masterList.lab = new LabMDM();
    this.masterList.lab = this.selectedLab;
    this.masterList.handler=this.selectedHandlerOption.name;

    this.masterList.machine = new Machine();
    this.masterList.machine=this.selectedMachineType;

    this.masterList.regexRunID=this.regexRunIdValue;

    this.masterList.location=this.locationValue;
    this.appendHistory("Inbound File Processing");
    this.blocked = true;
    this._mdmInboundFileService.updateInboundFileData(this.masterList).subscribe(
      results => {
        if (!results) {
          return;
        }
        masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
        this.masterLists = masterLists;
        this.masterList = null;
        this.displayMasterListDialog = false;
        this._messageService.addSuccessMessage({ severity: 'success', summary: 'Updated Inbound File Processing details!', detail: 'Inbound File Processing detail is Updated.' });
        this.blocked = false;
      },
      error => {
        this.handleError(error);
        }
    );

   }
   private handleError(error: any) {
    this.blocked = false;
    let message = this.errorHandler.handleError(error);
    this._messageService.addErrorMessage(message);
  }

  onRowSelect(event) {
    this.isNewMasterList = false;
    this.masterList = this.cloneMasterList(event.data);
    this.regexRunIdValue=this.masterList.regexRunID;
    this.locationValue=this.masterList.location
    this.displayMasterListDialog = true;
    this.getSelectedDropDownValues();
    this.getActiveOptionsForDropdowns();
  }

  cloneMasterList(list: any): any {
    let masterList = {};
    for (let prop in list) {
      masterList[prop] = list[prop];
    }
    return masterList;
  }

  getSelectedDropDownValues(){
    this.handlerOptions.forEach(options => {
      if(options.name == this.masterList.handler){
        this.selectedHandlerOption = {label: options.name, name: options.name};
      }
    });
  }

  appendHistory(tabName: string){
    let historyObj:OperetionHistoryDTO = new OperetionHistoryDTO();
    historyObj.puid = this.puid;
    historyObj.operationDateTime = new Date();
    historyObj.tabName = tabName;
    if(this.masterList.history){
      this.masterList.history.push(historyObj);
    } else {
      this.masterList.history = [];
      this.masterList.history.push(historyObj);
    }
  }
}